/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {enums} from 'types/enums';

export const TextLogFilter = yup.object({
   filterType: yup.string().oneOf(enums.filterType.keys).default(enums.filterType.enum.TEXT_FILTER),
   text: yup.string(),
});
export type ITextLogFilter = yup.InferType<typeof TextLogFilter>;
